import { DragDropDirective } from './drag-drop.directive';
import { OffClickDirective } from './off-click.directive';
import { SortableDirective } from './sortable.directive';
import { DraggableDroppableSortableDirective } from './draggable-droppable-sortable.directive';

export const CHASSIS_SUPPORT_DIRECTIVES = [
    DragDropDirective,
    DraggableDroppableSortableDirective,
    OffClickDirective,
    SortableDirective
];


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/directives/index.ts